import tuneInRequest from '../tuneInRequest';
export default function browseService(config, apiContext, applyReauth) {
    const url = `${config.domains.opml}/favorites.ashx`;
    function addFolder({ name }) {
        return tuneInRequest({
            url,
            params: {
                c: 'addFolder',
                name,
            },
        }, apiContext);
    }
    function removeFolder({ folderId }) {
        return tuneInRequest({
            url,
            params: {
                c: 'removeFolder',
                folderId,
            },
        }, apiContext);
    }
    function add(guideId) {
        return tuneInRequest({
            url,
            params: {
                c: 'add',
                id: guideId,
            },
        }, apiContext);
    }
    function updateInterests(guideIds, removeInterests) {
        return tuneInRequest({
            url,
            params: {
                c: removeInterests ? 'removeInterests' : 'addInterests',
                id: guideIds,
            },
        }, apiContext);
    }
    function remove(favoriteIdOrGuideId) {
        return tuneInRequest({
            url,
            params: {
                c: 'remove',
                id: favoriteIdOrGuideId,
                favoriteId: favoriteIdOrGuideId,
            },
        }, apiContext);
    }
    function order({ favoriteId, index }) {
        return tuneInRequest({
            url,
            params: {
                c: 'setSort',
                favoriteId,
                sortOrder: index,
            },
        }, apiContext);
    }
    function move({ favoriteId, folderId }) {
        return tuneInRequest({
            url,
            params: {
                c: 'move',
                favoriteId,
                folderId,
            },
        }, apiContext);
    }
    function setDefaultFolder({ folderId }) {
        return tuneInRequest({
            url,
            params: {
                c: 'setDefaultFolder',
                folderId,
            },
        }, apiContext);
    }
    return {
        addFolder: applyReauth(addFolder),
        removeFolder: applyReauth(removeFolder),
        add: applyReauth(add),
        remove: applyReauth(remove),
        order: applyReauth(order),
        move: applyReauth(move),
        setDefaultFolder: applyReauth(setDefaultFolder),
        updateInterests,
    };
}
